<template>
    <vx-card no-shadow v-if="loadedSettings">
        <div class="vx-row">
            <div class="vx-col w-4/12">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="vx-col border border-solid border-l-1 border-r-1 border-t-1 border-b-1 d-theme-border-grey-light rounded relative overflow-hidden items-no-padding p-3" >
                            <h5 class="text-primary mb-6"> {{ $t('paymentMethods') }} </h5>
                            <VuePerfectScrollbar class="scroll-area-upper pt-4" :settings="scrollSettings">
                                <payment-method :initialMethods="paymentMethods" @checked="val => paymentMethods = val" />
                            </VuePerfectScrollbar>
                        </div>
                    </div>
                </div>

                <div class="vx-row mt-4">
                    <div class="vx-col w-full">
                        <div class="vx-col border border-solid border-l-1 border-r-1 border-t-1 border-b-1 d-theme-border-grey-light rounded relative overflow-hidden items-no-padding p-3" >
                            <h5 class="text-primary"> {{ $t('taxes') }} </h5>
                            <taxes :initialTaxes="taxesValues" @change="val => taxesValues = val"/>
                        </div>
                    </div>
                </div>

                <div class="vx-row mt-4">
                    <div class="vx-col w-full">
                        <div class="vx-col border border-solid border-l-1 border-r-1 border-t-1 border-b-1 d-theme-border-grey-light rounded relative overflow-hidden items-no-padding p-3" >
                            <h5 class="text-primary mb-6"> {{ $t('eta') }} </h5>
                            <eta class="w-full" @change="val => etaValue = val" :initialEta="etaValue" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-8/12">
                <div class="vx-col border border-dashed border-l-1 border-r-1 border-t-1 border-b-1 d-theme-border-grey-light rounded relative overflow-hidden items-no-padding">
                    <delivery-map 
                        :initialExagons="hexagons"
                        @updatedHex="val => hexagons = val" />
                </div>
            </div>
            
            <vs-divider border-style="dashed" class="mt-10" /> 
            <div class="w-full ml-4">
                <vs-button 
                    id="btn-save"
                    class="vs-con-loading__container"
                    @click="saveSettings" 
                    color="primary"> SALVAR </vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import firebase from '@/firebase/firebase'
    import DeliveryMap from './DeliveryMap'
    import PaymentMethod from '../paymentMethod/PaymentMethod'
    import Eta from './Eta'
    import Taxes from '../taxes/Taxes.vue'

    export default {
        props : {
            visible : {
                type : Boolean,
                required : false
            }
        },

        components : {
            DeliveryMap,
            PaymentMethod,
            VuePerfectScrollbar,
            Eta,
            Taxes
        },

        data () {
            return {
                loadedSettings : false,
                ref : firebase.firestore().collection('company').doc(this.$store.getters.getCompanyID),
                paymentMethods : [],
                hexagons : [],
                etaValue : '',
                taxesValues : {},
                companyDoc : {},
                scrollSettings : {
                    maxScrollbarLength  : 40,
                    scrollXMarginOffset : 10,
                    wheelSpeed          : 0.2,
                },
                active : false
            }
        },

        mounted () {
            this.loadCompanyDoc()
        },

        watch : {
            visible (val) {
                this.active = val
            },

            active (val) {
                this.$emit('close', val)
            }
        },

        methods : {
            async saveSettings () {
                try {
                    this.$vs.loading({ container: '#btn-save', scale : 0.5 });

                    this.companyDoc.companyDoc = { 
                        deliveryConfig : {
                            taxes : this.taxesValues,
                            eta : this.etaValue,
                            allowedBoundary : this.hexagons,
                            paymentMethods : this.paymentMethods
                        }
                    }
                    await this.ref.update(this.companyDoc.companyDoc)

                    this.$success({
                        zIndex : 9999999,
                        title: 'Sucesso',
                        content: 'Alterações realizadas com sucesso'
                    })
                } catch  (err) {
                    this.$error({
                        zIndex: 9999999,
                        title: this.$t('error'),
                        content: `${this.$t('genericErrorMessage')} ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close('#btn-save > .con-vs-loading');
                }
            },

            async loadCompanyDoc () {
                try {
                    this.$vs.loading()

                    this.companyDoc = (await this.ref.get()).data()

                    this.loadedSettings = true
                    this.loadDefaultSettings()
                } catch (err) {
                    this.$error({
                        zIndex: 9999999,
                        title: this.$t('error'),
                        content: `${this.$t('genericErrorMessage')} ${err.message}`
                    })

                    this.active = false
                } finally {
                    this.$vs.loading.close()
                }
            },

            loadDefaultSettings () {
                if(this.companyDoc.hasOwnProperty('deliveryConfig')) {
                    this.taxesValues = this.companyDoc.deliveryConfig.taxes || {}
                    this.etaValue = this.companyDoc.deliveryConfig.eta || 'NADA'
                    this.paymentMethods = this.companyDoc.deliveryConfig.paymentMethods || []
                    this.hexagons = this.companyDoc.deliveryConfig.allowedBoundary || []
                }
                
            }
        }
    }
</script>

<style scoped lang="scss">
    .scroll-area-upper { 
        height: 17vh
    }

    .scroll-area-down { 
        height: 5vh
    }
</style>